import axios from "axios";

// -------------------------------------
// REGION CONFIG (env overrides)
// -------------------------------------
const regionConfig = {
  IND: {
    NODE: process.env.REACT_APP_API_BASE_URL_NODE || "https://rbdiagnostic.com:3000/",
    ORI: process.env.REACT_APP_API_BASE_URL_ORI || "https://rb-api.in:4436/api/",
    STAGING:process.env.REACT_APP_API_BASE_URL_STAGING || "http://staging.rb-api.in:5001/api/"
  
  },
  NP: {
    NODE: process.env.REACT_APP_API_BASE_URL_NODE || "https://rbdiagnostic.com:3010/",
    ORI: process.env.REACT_APP_API_BASE_URL_ORI || "https://np.rb-api.in/api/",
  },
};

// -------------------------------------
// Get saved region (default from build env)
// -------------------------------------
const getRegion = () => {
  return localStorage.getItem("country") || process.env.REACT_APP_DEFAULT_REGION || "IND";
};

// -------------------------------------
// Create axios instances
// -------------------------------------
let apiNode = axios.create({
  baseURL: regionConfig[getRegion()].NODE,
});

let apiOri = axios.create({
  baseURL: regionConfig[getRegion()].ORI,
});

let apiStaging = axios.create({
  baseURL: regionConfig[getRegion()].STAGING,
});

// -------------------------------------
// Recreate instances when region changes
// -------------------------------------
export const refreshClients = () => {
  const region = getRegion();

  apiNode = axios.create({
    baseURL: regionConfig[region].NODE,
  });

  apiOri = axios.create({
    baseURL: regionConfig[region].ORI,
  });
};

// -------------------------------------
// Change region (India / Nepal)
// -------------------------------------
export const setRegion = (region) => {
  localStorage.setItem("country", region);
  refreshClients();
};

// -------------------------------------
// Export axios instances
// -------------------------------------
export { apiNode, apiOri, apiStaging };

// Sync across tabs
window.addEventListener("storage", (e) => {
  if (e.key === "country") {
    refreshClients();
  }
});
